import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const AffiliatesDirectoryComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "AffiliatesDirectoryPage" */ "@circle-react/components/SettingsApp/PaywallsAffiliates/PaywallsAffiliatesDirectory"
    ),
);

export const AffiliatesDirectoryPage = () => (
  <Suspense fallback={<PageLoader />}>
    <AffiliatesDirectoryComponent />
  </Suspense>
);
